import { render, staticRenderFns } from "./richtext-content.vue?vue&type=template&id=78e4336a&"
import script from "./richtext-content.vue?vue&type=script&lang=js&"
export * from "./richtext-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports